module.exports = __webpack_public_path__ + "img/tropical.b9da5d1d.png";